/** Fallback if Redux resets before checkout submit (order slice is not persisted). */
export const CHECKOUT_RESUME_ORDER_ID_STORAGE_KEY =
  "wemust_checkout_resume_order_id";
